import Button from './Button';
import Dialog from './Dialog';

export default function ConfirmDialog({
  cancelLabel = 'Cancel',
  confirmLabel = 'Delete',
  destructive = true,
  loading = false,
  message,
  onCancel,
  onConfirm,
  open,
  title = 'Confirm action',
}) {
  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onCancel}
      role="alertdialog"
      title={title}
      footer={(
        <>
          <Button variant="ghost" onClick={onCancel} disabled={loading}>{cancelLabel}</Button>
          <Button variant={destructive ? 'danger' : 'primary'} onClick={onConfirm} loading={loading}>
            {confirmLabel}
          </Button>
        </>
      )}
    >
      <p>{message}</p>
    </Dialog>
  );
}
